<div class="row banner banner-error-page">
    <div class="col-lg-5 col-sm-7 justify-content-center align-self-center">
        <h1>Ooops, looks like you are <strong>lost in space.</strong></h1>
        <a routerLink="/" class="btn btn-primary">Go back home</a>
    </div>
    <img class="asset-astronaut" src="/assets/img/astro.gif" alt="astronaut">
    <img class="asset-moon" src="/assets/img/moon.png" alt="moon">
</div>



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/error/error-404.component.html